import React, { FC } from 'react';

import { SelectorOption } from 'components/pages/ProductDetails/types/SelectorOption';

const placeholderValue = 'placeholder';

export const SizeSelectorMobile: FC<{
  isOutOfStock?: boolean;
  selectSize: (optionValue: string) => void;
  selectedOption: SelectorOption;
  selectorOptions: SelectorOption[];
  selectorTitleText: string;
  sizeSystemAlias: string;
  trackOnSelectorClick: () => void;
}> = ({
  isOutOfStock,
  trackOnSelectorClick,
  selectedOption,
  selectSize,
  selectorOptions,
  selectorTitleText,
  sizeSystemAlias,
}) => {
  let label = isOutOfStock ? 'sold out' : selectorTitleText;
  if (selectedOption) {
    label = `Selected Size: ${selectedOption.size} ${sizeSystemAlias}`;
  }

  return (
    <>
      <select
        className={`size_options mobile ${isOutOfStock ? 'disabled' : ''}`}
        disabled={isOutOfStock}
        onChange={changeEvent => {
          const size = selectorOptions.find(({ value: selectorOptionValue }) => {
            return changeEvent.target.value === selectorOptionValue;
          });
          if (size && !size.disabled) {
            selectSize(size.value);
          }
        }}
        onClick={trackOnSelectorClick}
        value={selectedOption?.value || placeholderValue}
      >
        <option disabled value={placeholderValue}>
          {label}
        </option>

        {selectorOptions.map(option => (
          <option disabled={option.disabled} value={option.value}>
            {option.size}
            {sizeSystemAlias && ` ${sizeSystemAlias}`}
            {option.disabled && ' (Not Available)'}
            {option.numberAvailable === 1 && ' - Only 1 left*'}
          </option>
        ))}
      </select>

      <style jsx>{`
        .size_options {
          background-color: #fff;
          border-radius: 4px;
          border: 1px solid #000;
          cursor: pointer;
          font-size: 13px;
          height: 36px;
          width: 100%;
          padding: 0 15px;

          -webkit-appearance: none;
          -moz-appearance: none;
          appearance: none;

          background-image: url('https://cdn-images.italist.com/image/upload/v1601031860/icons/general/arrow_down_fontawesome.svg');
          background-repeat: no-repeat;
          background-position: 98% center;
          background-size: 12px;
          outline: none;
        }

        .size_options.disabled {
          background-color: #eeeeee;
        }
      `}</style>
    </>
  );
};
